module.exports = __webpack_public_path__ + "d30a1a74032490c6c6979c0ea839879d.svg";